import React, { useState, useEffect } from "react";
import { Modal, Table } from "reactstrap";
import { Form } from "react-final-form";
import CheckboxInputField from "@/shared/components/form/CheckboxInputField";

import "./HierarchyTable.css";

const SelectProgramModal = ({
  toggleHierarchyList,
  onSubmitHierarchyList,
  toggleHierarchyResult,
  setCheckedState,
  isOpenHierarchyList,
  hierarchyListData,
  checkedState,
  isOpenHierarchyResult,
  hierarchyListDataResult,
  programId,
}) => {
  useEffect(() => {
    setCheckedPrograms(checkedState || []);
  }, [checkedState]);
  const [checkedPrograms, setCheckedPrograms] = useState(checkedState);

  const selectProgramToHierarchy = (e, index) => {
    const tmpCheckedState = [...checkedState];
    tmpCheckedState[index].checked = !tmpCheckedState[index].checked;
    setCheckedPrograms(tmpCheckedState);
    setCheckedState(tmpCheckedState);
  };

  return (
    <>
      <Modal
        className="manager-program-settings-dialog modal-lg"
        isOpen={isOpenHierarchyList}
        toggle={toggleHierarchyList}
        centered
      >
        <div className="manager-program-settings-dialog__header">
          <div className="manager-program-settings-dialog__header-copy">
            <h4 className="manager-program-settings-dialog__title">Choose programs</h4>
            <p className="manager-program-settings-dialog__description">
              Select the programs that should receive this leaderboard update.
            </p>
          </div>
          <button
            type="button"
            className="manager-program-settings-dialog__close"
            onClick={toggleHierarchyList}
            aria-label="Close"
          >
            Close
          </button>
        </div>
        <div className="manager-program-settings-dialog__body">
          <Form onSubmit={onSubmitHierarchyList}>
            {({ handleSubmit }) => (
                <form className="manager-program-settings-dialog__form" onSubmit={handleSubmit}>
                  <div className="manager-program-settings-dialog__table-shell">
                  <Table className="manager-program-settings-dialog__table">
                    <thead>
                      <tr>
                        <th>Program Id</th>
                        <th>Program Name</th>
                        <th>Copy\\Update?</th>
                      </tr>
                    </thead>
                    <tbody>
                      {hierarchyListData.map((row, index) => (
                        <tr key={row.id}>
                          <td>{row.id}</td>
                          <td>{row.name}</td>
                          <td>
                            <div className="checkbox-custom2">
                              <CheckboxInputField
                                name={`action-checkbox-${row.id}`}
                                label={
                                  row.leaderboard_will_be_updated
                                    ? "update"
                                    : "add"
                                }
                                checked={
                                  checkedPrograms[index]?.checked || false
                                }
                                disabled={
                                  checkedPrograms[index]?.value === programId
                                    ? true
                                    : false
                                }
                                onChange={(e) =>
                                  selectProgramToHierarchy(e, index)
                                }
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  </div>
                  <p className="manager-program-settings-dialog__note">
                    Assigned events are not copied automatically when this leaderboard is pushed across the hierarchy.
                  </p>
                  <div className="manager-program-settings-dialog__actions">
                    <button
                      type="submit"
                      className="manager-program-settings-dialog__action is-primary"
                    >
                      Save selection
                    </button>
                    <button
                      type="button"
                      className="manager-program-settings-dialog__action"
                      onClick={toggleHierarchyList}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
            )}
          </Form>
        </div>
      </Modal>

      <Modal
        className="manager-program-settings-dialog modal-lg"
        isOpen={isOpenHierarchyResult}
        toggle={toggleHierarchyResult}
        centered
      >
        <div className="manager-program-settings-dialog__header">
          <div className="manager-program-settings-dialog__header-copy">
            <h4 className="manager-program-settings-dialog__title">Hierarchy update results</h4>
            <p className="manager-program-settings-dialog__description">
              This leaderboard was updated in the selected programs. Assigned events are not copied automatically.
            </p>
          </div>
          <button
            type="button"
            className="manager-program-settings-dialog__close"
            onClick={toggleHierarchyResult}
            aria-label="Close"
          >
            Close
          </button>
        </div>
        <div className="manager-program-settings-dialog__body">
          <div className="manager-program-settings-dialog__table-shell">
          <Table className="manager-program-settings-dialog__table">
            <thead>
              <tr>
                <th>Program Id</th>
                <th>Program Name</th>
                <th>Result</th>
              </tr>
            </thead>
            <tbody>
              {hierarchyListDataResult.map((row, index) => (
                <tr key={row.id}>
                  <td>{row.id}</td>
                  <td>{row.name}</td>
                  <td> {row.result}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          </div>
          <div className="manager-program-settings-dialog__actions">
            <button
              type="button"
              className="manager-program-settings-dialog__action is-primary"
              onClick={toggleHierarchyResult}
            >
              Done
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default SelectProgramModal;
